export const POSITIVE_REGEXP = /^\d*$/;
export const FLOAT_REGEXP = /^(?=.*)(?:\d+(?:\.\d{1,2})?)?$/;
export const FLOAT_NEG_REGEXP = /^[-]?(?=.+)(?:\d+(?:\.\d{1,2})?)?$/;

export function formatPrice(price: number): string {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(price);
}
